import { render, staticRenderFns } from "./CoreSelect.vue?vue&type=template&id=4558d848&scoped=true&"
import script from "./CoreSelect.vue?vue&type=script&lang=js&"
export * from "./CoreSelect.vue?vue&type=script&lang=js&"
import style0 from "./CoreSelect.vue?vue&type=style&index=0&id=4558d848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4558d848",
  null
  
)

export default component.exports